<script setup>
import {
  computed,
  onMounted,
  ref,
  toRefs,
  watch,
} from 'vue';
import { v7 as uuidv7 } from 'uuid';
import Swiper from 'swiper';
import { useI18n } from 'vue-i18n';
// eslint-disable-next-line import/no-unresolved
import 'swiper/css';
import IntroPreview from '@/components/preview/kakao/carousel-commerce-item/IntroPreview.vue';
import DefaultPreview from '@/components/preview/kakao/carousel-commerce-item/DefaultPreview.vue';
import PreviewHeader from '@/components/preview/kakao/common/PreviewHeader.vue';
import ConsentInformation from './ConsentInformation.vue';

let swiper;
const swiperElement = ref(null);
const { t } = useI18n();

const props = defineProps({
  brandCarouselCommerce: {
    type: Object,
    default: () => ({}),
  },
  position: {
    type: String,
    default: '',
  },
  kakaoProfile: {
    type: String,
    default: '',
  },
  swipeEnabled: {
    type: Boolean,
    default: false,
  },
});

const {
  brandCarouselCommerce,
  position,
  swipeEnabled,
} = toRefs(props);
const id = uuidv7();

const displayList = computed(() => (brandCarouselCommerce.value?.list || [])
  .map(({
    header,
    title,
    content,
    buttons,
    coupon = {},
    tail = {},
    image = {},
    regularPrice,
    discountPrice,
    discountRate,
    discountFixed,
    additionalContent,
    introEnabled,
  }, i) => ({
    componentName: i === 0 ? IntroPreview : DefaultPreview,
    imageUrl: image?.url,
    header,
    title,
    content,
    buttons,
    coupon,
    regularPrice,
    discountPrice,
    discountRate,
    discountFixed,
    introEnabled,
    additionalContent,
    tailEnabled: tail.enabled,
  })));

onMounted(() => {
  swiper = new Swiper(swiperElement.value, {
    slidesPerView: 'auto',
    spaceBetween: 15,
    // observer: true,
    // observeParents: true,
    allowTouchMove: false,
  });

  watch(swipeEnabled, (v) => {
    swiperElement.value.swiper.allowSlideNext = v;
    swiperElement.value.swiper.allowSlidePrev = v;
    swiperElement.value.swiper.allowTouchMove = v;
  }, { immediate: true });

  swiper.slideTo(brandCarouselCommerce.value.index, 0);

  watch(() => brandCarouselCommerce.value.index, (v) => {
    swiper.slideTo(v);
  });
});

const tailClass = computed(() => {
  if (!brandCarouselCommerce.value.tail?.enabled) {
    return 'd-none';
  }

  return position.value === 'carousel-commerce-tail' ? 'editAreaPositionHover' : '';
});

defineOptions({
  inheritAttrs: false,
});

</script>
<template>
  <div class="preview-talk preview-talk--active">
    <ConsentInformation />
    <div class="preview-inner mockup-scroll">
      <PreviewHeader
        :kakao-profile="kakaoProfile"
      />
      <div
        ref="swiperElement"
        class="preview-message preview-message__swiper carousel-feed
        carousel-commerce-feed preview-message--active"
      >
        <ul class="swiper-wrapper">
          <component
            v-for="(item, i) in displayList"
            :key="`preview-${id}-${i}`"
            :is="item.componentName"
            class="swiper-slide"
            :intro-enabled="item.introEnabled"
            :header="item.header"
            :content="item.content"
            :title="item.title"
            :image-url="item.imageUrl"
            :regular-price="item.regularPrice"
            :discount-price="item.discountPrice"
            :discount-rate="item.discountRate"
            :discount-fixed="item.discountFixed"
            :additional-content="item.additionalContent"
            :buttons="item.buttons"
            :coupon="item.coupon"
            :index="i"
            :position="position"
          />
          <div
            class="swiper-slide carousel-feed__more-view"
            :class="tailClass"
          >
            <div class="more-view">
              <a>
                <i></i>
                <span>{{ t('kakaoBasic.preview.tail') }}</span>
              </a>
            </div>
          </div>
        </ul>
      </div>
    </div>
  </div>
</template>
<style>
</style>
